import React, { useEffect, useState } from 'react';
import { X, Truck, Shield, Zap } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const PROMO_DISMISSED_KEY = 'allmx_promo_dismissed_v1';
const ROTATION_MS = 4500;

const PromoBanner = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const messages = {
    it: [
      { icon: Truck, text: 'Spedizione GRATIS in Italia per ordini superiori a €150', emphasis: 'GRATIS' },
      { icon: Zap, text: 'Spedizione veloce in 2-4 giorni lavorativi', emphasis: '2-4 giorni' },
      { icon: Shield, text: 'Pagamenti sicuri con Stripe e PayPal', emphasis: 'sicuri' }
    ],
    en: [
      { icon: Truck, text: 'FREE shipping in Italy on orders over €150', emphasis: 'FREE' },
      { icon: Zap, text: 'Fast shipping in 2-4 business days', emphasis: '2-4 days' },
      { icon: Shield, text: 'Secure payments with Stripe and PayPal', emphasis: 'Secure' }
    ],
    es: [
      { icon: Truck, text: 'Envío GRATIS en Italia para pedidos superiores a €150', emphasis: 'GRATIS' },
      { icon: Zap, text: 'Envío rápido en 2-4 días laborables', emphasis: '2-4 días' },
      { icon: Shield, text: 'Pagos seguros con Stripe y PayPal', emphasis: 'seguros' }
    ]
  };

  const activeMessages = messages[language] || messages.it;

  // Initialize visibility from localStorage and sync CSS var
  useEffect(() => {
    const dismissed = localStorage.getItem(PROMO_DISMISSED_KEY) === '1';
    setIsVisible(!dismissed);
  }, []);

  // Update CSS variable for header offset
  useEffect(() => {
    document.documentElement.style.setProperty('--promo-h', isVisible ? '36px' : '0px');
  }, [isVisible]);

  // Rotate messages
  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setActiveIndex((i) => (i + 1) % activeMessages.length);
    }, ROTATION_MS);
    return () => clearInterval(interval);
  }, [isVisible, activeMessages.length]);

  const handleDismiss = () => {
    localStorage.setItem(PROMO_DISMISSED_KEY, '1');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const current = activeMessages[activeIndex];
  const Icon = current.icon;

  // Highlight the emphasis word in orange
  const renderText = () => {
    const parts = current.text.split(current.emphasis);
    return (
      <>
        {parts[0]}
        <span className="font-bold" style={{ color: '#FF6600' }}>{current.emphasis}</span>
        {parts[1]}
      </>
    );
  };

  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center bg-black text-white border-b border-white/10"
      style={{ height: '36px' }}
    >
      <div className="flex items-center gap-2 px-4 text-xs sm:text-sm animate-fade-in" key={activeIndex}>
        <Icon className="w-4 h-4 flex-shrink-0" style={{ color: '#FF6600' }} />
        <span className="truncate">{renderText()}</span>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Chiudi banner promo"
        data-testid="promo-banner-close"
        className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/10 transition-colors"
      >
        <X className="w-4 h-4 text-white/70 hover:text-white" />
      </button>
    </div>
  );
};

export default PromoBanner;
